import { Button } from "@win-reality/react-ui";
import { X } from "lucide-react";

import { LineUpPlayer } from "../../types/gameFull";
import { formatPlayerName } from "../../utils/playerName";
import { PlayerName, RowShell } from "./PlayerRows";

const sideLetter = (side?: string) => side?.charAt(0).toUpperCase() || "-";

type PlayersToAddProps = {
  players: LineUpPlayer[];
  onRemove: (player: LineUpPlayer) => void;
  /** Literal ids from the call site; see TEST_IDS.md */
  itemTestId?: string;
  removeButtonTestId?: string;
};

/** The players picked or created in the Add Players modal, in order. */
export const PlayersToAdd = ({
  players,
  onRemove,
  itemTestId,
  removeButtonTestId,
}: PlayersToAddProps) => (
  <div className="space-y-1.5">
    <div className="text-sm font-semibold">
      Players to Add{players.length > 0 && ` (${players.length})`}
    </div>
    {players.length === 0 ? (
      <div className="pr-3 py-4 text-sm text-tagging-muted">
        Add players from the search, or create new ones
      </div>
    ) : (
      <div className="space-y-2">
        {players.map((player) => (
          <RowShell
            key={player.playerId}
            data-testid={itemTestId}
            data-player-id={player.playerId}
          >
            <PlayerName player={player} />
            <span className="shrink-0 text-xs text-tagging-muted">
              B/T {sideLetter(player.hitSide)}/{sideLetter(player.pitchSide)}
            </span>
            <Button
              variant="ghost"
              size="icon-sm"
              onClick={() => onRemove(player)}
              aria-label={`Remove ${formatPlayerName(player.name)}`}
              data-testid={removeButtonTestId}
              data-player-id={player.playerId}
              className="shrink-0 text-tagging-muted hover:text-red-500"
            >
              <X className="h-4 w-4" />
            </Button>
          </RowShell>
        ))}
      </div>
    )}
  </div>
);
